module.exports = __webpack_public_path__ + "img/rws-white-logo.2c8b0b5a.svg";